import React from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import routes from '../../../config/routes'
import Text from '../Text/Text'
import Avatar from '../Avatar/Avatar'
import styles from './userTopBar.module.scss'

const UserTopBar = (props) => {
  const { name, profileImageUrl } = props

  const [firstName, secondName] = name.split(' ')

  return (
    <Link to={routes.profile.path}>
      <div className={styles.container}>
        <div className={styles.avatar}>
          <Avatar title={name} image={profileImageUrl} size="small" />
        </div>

        <Text
          size="xs"
          color="gray"
          variation="dark"
          extraBold
          font="custom"
          className={styles.name}
        >
          {!name
            ? 'N/A'
            : `${firstName} ${secondName ? `${secondName.substr(0, 1)}.` : ''}`}
        </Text>
      </div>
    </Link>
  )
}

UserTopBar.defaultProps = {
  profileImageUrl: null,
  name: null
}

UserTopBar.propTypes = {
  name: PropTypes.string,
  profileImageUrl: PropTypes.string
}

export default UserTopBar
